import type { SortType } from '@store/reducers/dashboard/types'

export const SortTitles: Record<SortType, string> = {
  abc: 'Alphabetically',
  created: 'Date created',
  updated: 'Last updated',
}
